import { TextSelection } from '@tiptap/pm/state';
import { Command, getMarkRange, getMarkType } from '@tiptap/react';

// adapted from extendMarkRange but instead of selecting the specified mark,
// it moves to the end of the mark. We use it to position the cursor after the link
// once user creates or updates the link, effectively closing the Link menu (if any)
export const moveToEndOfMarkRange =
  (typeOrName: string, attributes: Record<string, any> = {}): Command =>
  ({ tr, state, dispatch }) => {
    if (dispatch) {
      const type = getMarkType(typeOrName, state.schema);
      const { doc, selection } = tr;
      const { $from, from, to } = selection;

      const range = getMarkRange($from, type, attributes);

      if (range && range.from <= from && range.to >= to) {
        const newSelection = TextSelection.create(doc, range.to);

        tr.setSelection(newSelection);
      }
    }

    return true;
  };
